

























































































import Vue, { PropType } from "vue";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Selectbox from "@/components/Atoms/Forms/Selectbox/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";

import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PlanFloatingView",
  components: {
    Overlay,
    FloatingView,
    Heading,
    Button,
    ButtonConfig,
    Selectbox,
    TextField,
    Caption
  },
  props: {
    availableGraduateYears: {
      type: Array as PropType<Props["availableGraduateYears"]>,
      required: true
    },
    initialGraduateYear: {
      type: String,
      required: true
    },
    initialName: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    },
    placeholderText: {
      type: String,
      default: ""
    },
    submitButtonText: {
      type: String,
      required: true
    },
    disabledSubmitButton: {
      type: Boolean,
      default: false
    },
    disabledSelectBox: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    },
    deleteBtnVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // TODO: 複製の方へ移す
    validatedInitialGraduateYear() {
      const isAvailableInitialGraduateYear = this.availableGraduateYears.some(
        availableGraduateYear =>
          availableGraduateYear.value === this.initialGraduateYear
      );
      return isAvailableInitialGraduateYear
        ? this.initialGraduateYear
        : this.availableGraduateYears[0].value;
    },
    deleteClass() {
      return this.deleteBtnVisible ? "floatingView__form__buttons--delete" : "";
    }
  },
  methods: {
    handleInputGraduateYear(graduateYear) {
      this.$emit("inputGraduateYear", Number(graduateYear));
    },
    handleFocusName() {
      this.$emit("clickName");
    },
    handleChangeName(name) {
      this.$emit("changeName", name);
    },
    handleClickCancel() {
      this.$emit("cancel");
    },
    handleClickSubmit() {
      this.$emit("submit");
    },
    handleClickDelete() {
      this.$emit("delete");
    }
  }
});
